import {
  TableCell,
  TableRow,
} from '@mui/material';
import { styled } from '@mui/styles';
import { format, intervalToDuration } from 'date-fns';
import { IAdminReport } from 'types/AdminReport';
import ptBR from 'date-fns/locale/pt-BR';

const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fafafa',
  },
}));

const StyledTableCell = styled(TableCell)(() => ({
  color: '#4B4B4B',
}));

export interface IAdminReportRow {
  adminReport: IAdminReport;
}

export const AdminReportRow: React.FC<IAdminReportRow> = ({
  adminReport,
}) => {

  return (
    <>
      <StyledTableRow>
        <StyledTableCell>{adminReport?.tutor?.name}</StyledTableCell>
        <StyledTableCell>{adminReport.vet.name}</StyledTableCell>
        <StyledTableCell>{format(new Date(adminReport.createdAt), 'PPpp', { locale: ptBR })}</StyledTableCell>
        <StyledTableCell>{adminReport?.symptoms[0]?.name ?? '-'}</StyledTableCell>
        <StyledTableCell>{adminReport.evaluation.grade > 0 ? adminReport.evaluation.grade : 'NA'}</StyledTableCell>
        <StyledTableCell>{adminReport.finishedAt ? intervalToDuration({ start: new Date(adminReport.createdAt), end: new Date(adminReport.finishedAt) }).minutes + " min"  : '-'}</StyledTableCell>
        <StyledTableCell>{adminReport.startedQueueAt ? intervalToDuration({ start: new Date(adminReport.startedQueueAt), end: new Date(adminReport.finishedQueueAt) }).minutes + " min"  : '-'}</StyledTableCell>
        <StyledTableCell>{adminReport.treatmentHappened ? 'Sim' : 'Não'}</StyledTableCell>
      </StyledTableRow>
    </>
  );
};

